<!--
* UIID:
* UI Name: Codes
* Modify Date: 2020/12/21
-->
<template>
  <div class="container">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{$t('lbl.codes.page_header')}}</v-toolbar-title>
      </v-col>
    </v-row>

    <!-- Condition search -->
    <!-- /**
     * 2021.07.26 203737 SPKA-161 issue 110 Change all text field and combo box style for search condition [Management]
     */ -->
    <v-row class="custom-form-control custom-figma-1 mb-0">
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col class="comm-header-col data-query-section custom-field-combo custom-figma-1 pb-0 pt-0 mt-0" cols="12" lg="6" md="6">
            <v-row>
              <v-col cols="12" lg="4" md="4" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="codeType"
                  :items="codeTypeItems"
                  dense
                  class="custom-selectbox"
                  @change="changeCodeType"
                  filled
                  :label="$t('lbl.common.conditionSearch.search')"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="comm-header-col date-query-section pb-0 pt-0 pr-0 mt-0" cols="12" lg="6" md="6" >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <component :is="selectedComponent"></component>
  </div>
</template>

<script>
  import searchKeyList from '@/vue-caas/views/codes/SearchKeyList.vue'
  import messageCodeList from '@/vue-caas/views/codes/MessageCodeList.vue'
  import deliverySiteCodeList from '@/vue-caas/views/codes/DeliverySiteCodeList.vue'
  import config from '@/vue-caas/config/config.js';

  const isDlb = config.isDlb;

  export default {
    components: {
      searchKeyList,
      messageCodeList,
      deliverySiteCodeList,
    },
    props: {

    },

    data(){
      return{
        codeType:'',
        codeTypes: [
          {text: 'Search Key', value: 'S'},
          {text: 'Message Code', value: 'M'},
          {text: 'Delivery Site Code', value: 'D'},
        ],
        codeTypeDlb: [
          {text: 'Message Code', value: 'M'},
          {text: 'Delivery Site Code', value: 'D'},
        ],
        selectedComponent: '',
    }},

    computed: {
      codeTypeItems() {
        if(isDlb) {
          this.codeType = 'M';
          return this.codeTypeDlb;
        } else {
          this.codeType = 'S';
          return this.codeTypes;
        }
      }
    },

    watch: {

    },

    methods: {
      changeCodeType () {
        if ( this.codeType === "S" )
          this.selectedComponent = `searchKeyList`;
        if ( this.codeType === "M" )
          this.selectedComponent = `messageCodeList`;
        if ( this.codeType === "D" )
          this.selectedComponent = `deliverySiteCodeList`;
      }
    },

    created() {
      this.codeType = isDlb ? 'M' : 'S';
      this.changeCodeType ();
    },
  }
</script>
